import React, { Component } from "react";
import "./styles.css";
import $ from "classnames";

export const Heading = (props) => {
  let className = props.className ? props.className : "col-xs-12";

  return (
    <div className="row">
      <div className={className}>
        <div className="iam-header">{props.children}</div>
      </div>
    </div>
  );
};

export const Content = (props) => {
  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="iam-content">{props.children}</div>
      </div>
    </div>
  );
};

export const Footer = (props) => {
  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="iam-footer">{props.children}</div>
      </div>
    </div>
  );
};

export const Row = (props) => {
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="row">{props.children}</div>
      </div>
    </div>
  );
};

export const Left = (props) => {
  const type = props.type ? props.type : "constrain";
  const className = type === "constrain" ? "col-md-8" : "col-md-12";

  return (
    <div className="col-sm-7 col-md-9">
      <div className="row">
        <div className={className}>
          {type === "full" ? (
            <>
              {props.children.map((child, index) => {
                let element = child;
                if (child.type === Heading) {
                  element = React.cloneElement(child, {
                    className: "col-md-8",
                    key: index,
                  });
                }
                return element;
              })}
            </>
          ) : (
            <>{props.children}</>
          )}
        </div>
      </div>
    </div>
  );
};

export const Right = (props) => {
  return <div className="col-sm-5 col-md-3">{props.children}</div>;
};

export const Layout = (props) => {
  return (
    <div id="content" tabIndex="-1" className={$(styles.page, props.pageName)}>
      <div className="container">
        <div className="row">{props.children}</div>
      </div>
    </div>
  );
};

export const Container = (props) => {
  return (
    <div className="iam-wrapper">
      <div
        id="content"
        tabIndex="-1"
        className={$("iam-container", props.pageName)}
      >
        <div className="iam-content-limit">{props.children}</div>
      </div>
    </div>
  );
};

export default Layout;
